import { useQuery } from 'react-query';

import {
  GROUP_SUBSCRIPTION_KEY,
  GroupSubscriptionType,
  getGroupSubscriptionsRecipients,
} from '../utils/backend-api/groupSubscriptions';

export default function useGroupSubscriptionsRecipients(
  groupSubscriptionType: GroupSubscriptionType
) {
  const { data, isLoading } = useQuery([GROUP_SUBSCRIPTION_KEY, groupSubscriptionType], () =>
    getGroupSubscriptionsRecipients(groupSubscriptionType)
  );
  return { data, isLoading };
}
